export class ItemVariant {
    variantId:string;
    variantName:string;
    isActive:boolean;
    constructor(variantId:string,variantName:string,isActive:boolean){
        this.variantId=variantId;
        this.variantName=variantName;
        this.isActive=isActive;
    }
  }